/**
 * 专业优先院校优先 以及查学校 公用一个组件
 */

import React, { useState, useEffect } from 'react'
import FillSearch from 'components/FillSearch'
import { SelectProps } from 'antd/es/select'
import { querySchoolList, schoolQueryList } from 'servers/common/index'
import useStore from 'store'
import { addRlog } from 'utils/util'
import s from './index.module.less'

/* eslint-disable */
interface IProps {
  resNumber?: number // 院校数量
  hasAuth: boolean
  keyName?: string
  type: string // 院校优先or专业优先
  typeValue: number // 当前模式下数量
  findType: string // 当前模式的文案
}

const FillFind: React.FC<IProps> = ({ resNumber, hasAuth, type, keyName, findType, typeValue }) => {
  const { dispatch } = useStore()
  const [schoolRes, setSchoolRes] = useState<SelectProps<object>['options']>([]) // 搜索下拉列表
  const [curSchool, setCurSchool] = useState('') // 检索的学校名字
  const [selectValue, setSelectValue] = useState(undefined) // 当前输入框的内容

  const handleSearch = async (val) => {
    setSelectValue(val)
    if (!val) setCurSchool('')
    const isEnrollName = keyName === 'enrollName'
    const res = isEnrollName ? await querySchoolList(val) : await schoolQueryList(val)
    const temp = (isEnrollName ? res.data : Object.values(res.data)).map((v) => ({
      ...v,
      historyValue: isEnrollName ? v[keyName || 'enrollName'] : v
    }))
    if (res.code === 0) setSchoolRes(temp)
  }
  const handleChange = (val) => {
    setCurSchool(val)
    setSelectValue(val)
  }

  const clickSearch = () => {
    addRlog('click', {
      click_location: '院校名称搜索',
      page_name: type,
      value: selectValue
    })
    if (!hasAuth) {
      dispatch({ type: 'updateFillModalVisible', payload: true })
      return
    }
    setCurSchool(selectValue || '')
  }

  const setSchoolResFun = (data) => {
    setSchoolRes(data)
  }

  useEffect(() => {
    // 更新检索变量
    dispatch({
      type: 'updateFilterParamsData',
      payload: { [keyName || 'enrollName']: curSchool, page: 1 }
    })
  }, [curSchool])

  return (
    <section className={s.FillFind}>
      <p className={s.resultTitle}>
        找到符合条件的{findType} <span> {typeValue} </span> {findType === '院校' ? '所' : '个'}
        {findType === '专业' && (
          <>
            {' '}
            <i>|</i> 院校<span> {resNumber}</span> 所
          </>
        )}
      </p>
      <p className={s.search}>
        <FillSearch
          handleChange={handleChange}
          handleSearch={handleSearch}
          searchRes={schoolRes}
          clickSearch={clickSearch}
          curValue={curSchool}
          historyName="schoolHistory"
          setSearchRes={setSchoolResFun}
        />
      </p>
    </section>
  )
}

FillFind.defaultProps = {
  resNumber: 0,
  type: '专业',
  keyName: 'enrollName'
}

export default FillFind
